import React, { useState, useEffect } from 'react';
import { useAppContext } from '@/context/AppContext';
import FieldGroup from '@/components/FieldGroup';
import SectionTitle from '@/components/SectionTitle';
import Dropdown from '@/components/Dropdown';
import { categories } from '@/data/categories';

const complexityOptions = [
  { value: 'simple', label: 'Simple' },
  { value: 'medium', label: 'Medium' },
  { value: 'complex', label: 'Complex' },
];

const categoryOptions = categories.map(cat => ({ value: cat.id, label: cat.label }));

function Step2Configuration() {
  const { projectDraft, dispatch } = useAppContext();
  const [subCategoryOptions, setSubCategoryOptions] = useState([]);
  const [showOtherSubCategory, setShowOtherSubCategory] = useState(false);

  useEffect(() => {
    if (projectDraft.category) {
      const selectedCat = categories.find(c => c.id === projectDraft.category);
      const options = selectedCat ? selectedCat.subcategories.map(sc => ({ value: sc, label: sc })) : [];
      setSubCategoryOptions(options);
    } else {
      setSubCategoryOptions([]);
    }
  }, [projectDraft.category]);

  useEffect(() => {
    setShowOtherSubCategory(projectDraft.subCategory === 'Other');
  }, [projectDraft.subCategory]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let payload = { [name]: value };
    
    if (name === 'category') {
      payload.subCategory = ''; // Reset subcategory when category changes
    }
    
    dispatch({ type: 'UPDATE_PROJECT_DRAFT', payload });
  };

  return (
    <div>
      <SectionTitle title="Step 2: Configuration" subtitle="Set up the technical foundation of your project." />
      <div className="space-y-6">
        <FieldGroup label="Category">
          <Dropdown
            options={categoryOptions}
            name="category"
            value={projectDraft.category || ''}
            onChange={handleChange}
            placeholder="Select a category"
          />
        </FieldGroup>
        
        {projectDraft.category && (
          <FieldGroup label="Sub-category">
            <Dropdown
              options={subCategoryOptions}
              name="subCategory"
              value={projectDraft.subCategory || ''}
              onChange={handleChange}
              placeholder="Select a sub-category"
            />
          </FieldGroup>
        )}

        {showOtherSubCategory && (
            <FieldGroup label="Please specify 'Other' sub-category">
                <input
                    type="text"
                    name="otherSubCategory"
                    value={projectDraft.otherSubCategory || ''}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm"
                />
            </FieldGroup>
        )}
        
        <FieldGroup label="Project Complexity">
          <Dropdown
            options={complexityOptions}
            name="complexity"
            value={projectDraft.complexity || ''}
            onChange={handleChange}
            placeholder="Select complexity"
          />
        </FieldGroup>
        
        <FieldGroup label="Framework">
          <input type="text" value="React (Vite)" readOnly className="mt-1 block w-full rounded-md border-gray-300 shadow-sm bg-gray-100 sm:text-sm" />
        </FieldGroup>
        
        <FieldGroup label="Styling">
          <input type="text" value="TailwindCSS" readOnly className="mt-1 block w-full rounded-md border-gray-300 shadow-sm bg-gray-100 sm:text-sm" />
        </FieldGroup>
      </div>
    </div>
  );
}

export default Step2Configuration;